import { classNames } from 'libs/growth-platform-brand-system-v2/src/utils/style';
import React, { useRef } from 'react';
import { Burger } from './burger';
import { ButtonsHeader } from './ButtonsHeader';
import { ButtonsMobile } from './ButtonsMobile';
import { HeaderPayfitLogo } from './HeaderPayfitLogo';
import { MenuLinks } from './MenuLinks';
import { useHamburgerMenu } from './useHamburgerMenu';

export const Menu = ({
  headerButton,
  mobileButton,
  submenuDropdownOpen,
  menuItems,
  locale,
  handleSubmenuClick,
  menu,
  pageContext,
}: any) => {
  const menuRef = useRef<HTMLDivElement>(null);
  const { toggleMenu, isOpen } = useHamburgerMenu(menuRef);
  return (
    <div
      ref={menuRef}
      className={classNames(
        'Menu flex h-[70px] items-center',
        'lg:mx-[24px] xl:mx-auto xl:max-w-1248',
        'flex-wrap xl:flex-nowrap',
        'w-full',
      )}
    >
      <HeaderPayfitLogo
        {...{
          menu,
          locale,
        }}
        className="xl:order-1"
      />
      <nav
        id="main_menu"
        className={classNames(
          'MenuMain xl:ml-40 xl:flex xl:flex-col',
          'order-3 w-full xl:order-2 xl:h-[70px] xl:w-auto justify-center',
          'hidden',
          'justify-center',
        )}
      >
        <div className={classNames('flex flex-col gap-40')}>
          <MenuLinks
            submenuDropdownOpen={submenuDropdownOpen}
            menuItems={menuItems}
            locale={locale}
            handleSubmenuClick={handleSubmenuClick}
          />
          <ButtonsMobile mobileButtons={mobileButton} locale={locale} />
        </div>
      </nav>
      <nav className="ml-auto flex h-[70px] list-none items-center gap-12 xl:order-3">
        <ButtonsHeader
          headerButtons={headerButton}
          locale={locale}
          className={classNames('hidden xs:flex')}
        />

        {menuItems?.length > 0 && (
          <Burger
            className={classNames('ml-12 block xl:hidden')}
            onClick={toggleMenu}
            isOpen={isOpen}
            onKeyUp={(e: any) => {
              if (e.key === ' ' || e.key === 'Enter') {
                (
                  document.querySelector(
                    '.MenuMain a, .MenuMain button',
                  ) as HTMLElement
                )?.focus();
              }
            }}
          />
        )}
      </nav>
    </div>
  );
};
